// src/components/KiteBanner.jsx
// Shows a gentle prompt when Kite credentials are not configured.
// Only renders when kiteReady === false (null = still checking, true = configured).
// Dismissible — user can close it; it re-appears after logout/login.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DISMISSED_KEY = 'kiteBannerDismissed';

export default function KiteBanner({ message }) {
  const { kiteReady } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === 'true'
  );

  if (kiteReady !== false || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 0.9rem',
      marginBottom: '0.75rem',
      borderRadius: 6,
      background: '#0c1a2e',
      border: '1px solid #0369a1',
      fontSize: '0.82rem',
      color: '#7dd3fc',
    }}>
      <span style={{ flexShrink: 0 }}>ℹ️</span>
      <span style={{ flex: 1 }}>
        {message || 'Zerodha Kite is not configured — live trading features are unavailable.'}{' '}
        <Link to="/settings" style={{ color: '#38bdf8', fontWeight: 700, textDecoration: 'none' }}>
          Set up in Settings →
        </Link>
      </span>
      <button
        onClick={dismiss}
        style={{
          background: 'none', border: 'none', color: '#7dd3fc',
          cursor: 'pointer', fontSize: '1rem', lineHeight: 1,
          padding: '0 0.25rem', flexShrink: 0, opacity: 0.7,
        }}
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
